import type { Env } from "shared/types/Env";

export function getHostEnvironment(): Env | "unknown" {
  const host = window.location.host;
  switch (host) {
    case "slfus-client-onboard.maxwellhealth.com":
    case "onboard.sunlifeconnect.com":
    case "yourbenefitsexplorer.com":
      return "prod-dcs";
    case "slfus-client-onboard.stage-dcs.sunlifeus.cloud":
    case "staging-slfus-client-onboard.maxwellhealth.com":
    case "staging-onboard.sunlifeconnect.com":
    case "stage-dcs.yourbenefitsexplorer.com":
      return "stage-dcs";
    case "qa-slfus-client-onboard.maxwellhealth.com":
    case "qa-onboard.sunlifeconnect.com":
    case "qa-dcs.yourbenefitsexplorer.com":
      return "qa-dcs";
    case "localhost:1234":
    case "localhost:5123":
      return "local";
    default:
      return "unknown";
  }
}
